import type { PositionDto } from '../../lib/api/endpoints';
import { cn } from '../../lib/utils';

export function PositionSideBadge({
  shortProvenance,
  side,
}: {
  shortProvenance?: PositionDto['shortProvenance'];
  side: PositionDto['side'];
}) {
  const unresolved = side === 'SHORT' && shortProvenance === 'AMBIGUOUS_PREHISTORY';

  return (
    <span
      aria-label={
        unresolved
          ? 'Position side unresolved: sell-first history incomplete'
          : `Position side: ${side}`
      }
      className={cn(
        'rounded px-1.5 py-0.5 text-[10px] font-bold tracking-wide',
        unresolved
          ? 'bg-warn-subtle text-warn'
          : side === 'SHORT'
            ? 'bg-danger-subtle text-danger'
            : 'bg-success-subtle text-success',
      )}
    >
      {unresolved ? 'UNRESOLVED' : side}
    </span>
  );
}
